import types from "./types";
import StoreTypes from "../../../store/types";

const initialState = {
  putPartnerInCharge: false,
  executor: {},
  coExecutor: {},
  alternateExecutor: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PARTNER_AS_EXECUTOR:
      return { ...state, putPartnerInCharge: action.payload };

    case types.SET_EXECUTOR:
      return { ...state, executor: action.payload };

    case types.SET_COEXECUTOR:
      return { ...state, coExecutor: action.payload };

    case types.SET_ALT_EXECUTOR:
      return { ...state, alternateExecutor: action.payload };

    case StoreTypes.SET_DETAILS:
      return {
        ...state,
        executor: action.payload.executor?.executor,
        alternateExecutor: action.payload.executor?.alternateExecutor,
        coExecutor: action.payload.executor?.coExecutor,
      };

    default:
      return state;
  }
};

export default reducer;
